import { mapActions} from 'vuex'
import { EventHub } from "@/constants/constants"
import { dialogTypes } from "@/constants/dialogTypes"
import { rgbToHex } from '@/tools/functions'
import { DialogType } from '@/constants/constants'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'EventEditionTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        selectedType: {
            type: String,
            required: false
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        tableHeaders: [],
        flags: {
            en: 'us',
            es: 'es',
            pt: 'br',
            fr: 'fr'
        },
        tableFilter: null,
        tableData: [],
        selectedTypeData: '',
        selectedTypeDataId: ''
    }),
    computed: {
        /**
         * Chequea si el event tiene algún error entre las propiedades.
         * Setea el estado de error y el mensaje a mostrar
         */
        eventErrorMessage () {
            const result = !this.validEvent(this.tableData) || !this.isValidForm ? this.$t('enterprise.eventDialog.stateError') : null
            if (result) {
                this.eventsState[this.selectedEvent] = { icon: 'mdi-close-circle', color: 'error', text: this.$t('enterprise.eventDialog.stateError')}
            } else if (!this.eventEmpty) {
                this.eventsState[this.selectedEvent] = { icon: 'mdi-check-circle', color: 'success', text: this.$t('enterprise.eventDialog.stateSuccess')}
            }
            return result
        },
        eventEmpty () {
            const result = !this.tableData || this.tableData.length <= 0 ? this.$t('enterprise.eventDialog.stateWarning') : null
            if (result) {
                this.eventsState[this.selectedEvent] = this.eventsState[this.selectedEvent] = { icon: 'mdi-alert-circle', color: 'warning', text: this.$t('enterprise.eventDialog.stateWarning')}
            }
            return result
        }
    },
    created () {
        this.$eventBus.$on(EventHub.COMMIT_EVENT, (event) => {
            this.model.eventConfigurations[this.selectedTypeDataId].push(event)
            this.filterTable()
        })
        this.$eventBus.$on(EventHub.UPDATE_EVENT, ({ event, index }) => {
            this.model.eventConfigurations[this.selectedTypeDataId].splice(index, 1, event)
            this.filterTable()
        })
    },
    beforeDestroy() {
        this.$eventBus.$off(EventHub.COMMIT_EVENT)
        this.$eventBus.$off(EventHub.UPDATE_EVENT)
    },
    mounted () {
        this.selectedTypeData = this.selectedType
        this.selectedTypeDataId = this.selectedType
        this.tableHeaders = [
            { text: '', value: 'actions' },
            { text: this.$t('enterprise.eventDialog.eventNumber'), value: 'eventNumber' },
            { text: this.$t('enterprise.eventDialog.eventName.title'), value: 'eventName' },
            { text: this.$t('enterprise.eventDialog.eventColor'), value: 'eventColor' },
            { text: this.$t('enterprise.eventDialog.stateName.title'), value: 'stateName' },
            { text: this.$t('enterprise.eventDialog.stateColor'), value: 'stateColor' },
        ]
    },
    methods: {
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        addEventConfig () {
            if (!this.model.eventConfigurations[this.selectedTypeDataId]) {
                this.model.eventConfigurations[this.selectedTypeDataId] = []
            }
            const model = {
                eventNumber: null,
                eventType: null,
                eventName: {
                    es: null,
                    en: null,
                    pt: null,
                    fr: null
                },
                eventColor: '#FF3333',
                stateType: null,
                stateName: {
                    es: null,
                    en: null,
                    pt: null,
                    fr: null
                },
                stateColor: '#FF3333'
            }
            model.eventNumbers = this.model.eventConfigurations[this.selectedTypeDataId].map(c => c.eventNumber)
            model.update = false
            model.enterpriseId = this.model.enterpriseId
            const bread = {
                key: dialogTypes.EVENT.key,
                disabled: true,
                model,
                text: this.$t('enterprise.eventDialog.eventAndState')
            }
            this.$emit('editingEvent')
            this.pushBread(bread)
        },
        deleteEventConfig (tableProps) {
            this.model.eventConfigurations[this.selectedTypeDataId].splice(this.model.eventConfigurations[this.selectedTypeDataId].indexOf(tableProps.item), 1)
            this.filterTable()
        },
        editEventConfig (tableProps) {
            const model = Object.assign({}, tableProps.item)
            model.editingIndex = this.model.eventConfigurations[this.selectedTypeDataId].indexOf(tableProps.item)
            if (model.eventType && model.eventColor && model.eventColor[0] !== '#' ) {
                model.eventColor = rgbToHex(model.eventColor)
            }
            if (model.stateType && model.stateColor && model.stateColor[0] !== '#' ) {
                model.stateColor = rgbToHex(model.stateColor)
            }
            model.eventColor = model.eventColor ? (model.eventColor[0] === '#' ? model.eventColor : rgbToHex(event.color)) : model.eventColor
            model.stateName = model.stateName || { es: null, en: null, pt: null, fr: null }
            model.eventNumbers = this.model.eventConfigurations[this.selectedTypeDataId].map(c => c.eventNumber).filter(e => e !== tableProps.item.eventNumber)
            model.update = true
            model.enterpriseId = this.model.enterpriseId
            const bread = {
                key: dialogTypes.EVENT.key,
                disabled: true,
                model,
                text: this.$t('enterprise.eventDialog.eventAndState')
            }
            this.$emit('editingEvent')
            this.pushBread(bread)
        },
        validEvent (event) {
            if (event.filter(r => !r.property).length > 0) {
                return false
            }
            let seen = new Set()
            return !(event.some(e => seen.size === seen.add(e.property).size))
        },
        applyEnterpriseConfig () {
            this.openDialog({
                title: this.$t('enterprise.rusDialog.applyEnterpriseConfig'),
                text: this.$t('enterprise.rusDialog.applyEnterpriseConfigConfirmation'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    this.model.eventConfigurations[this.selectedTypeDataId].cleanAndUpdate(this.model.enterpriseEventConfiguration);
                    this.filterTable()
                },
                noAction: () => {
                }
            })
        },
        filterTable() {
            if (this.selectedTypeDataId) {
                if (this.tableFilter) {
                    this.tableData.cleanAndUpdate(this.model.eventConfigurations[this.selectedTypeDataId].filter(t => {
                        return t.eventName.es.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        t.eventName.en.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        t.eventName.pt.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        (t.eventName.fr || '').toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        (t.stateName && (
                        t.stateName.es.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        t.stateName.en.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        t.stateName.pt.toLowerCase().includes(this.tableFilter.toLowerCase()) ||
                        (t.stateName.fr || '').toLowerCase().includes(this.tableFilter.toLowerCase())))
                    }))
                } else {
                    this.tableData.cleanAndUpdate(this.model.eventConfigurations[this.selectedTypeDataId])
                }
            }


        },
        selectedTypeFunction(newVal) {
            if (newVal) {
                this.selectedTypeDataId = newVal._id;
                this.filterTable()
            }
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal  && this.$refs.eventConfigurationForm) {
                this.$refs.eventConfigurationForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                this.model = newModel
                if (newModel.eventConfigurations) {
                    this.filterTable()
                }
            }
        },
        selectedType(newVal, oldVal) {
            if(newVal!==oldVal){
                this.selectedTypeData = newVal
                this.selectedTypeDataId = newVal
                this.filterTable()
            }
        }
    }
}
